module.exports = __webpack_public_path__ + "img/Path -1.b74ec8cf.svg";